import {  Text,  Card, Divider, useMantineTheme, Title } from '@mantine/core';


export function MemberInfo(props) {
    const theme = useMantineTheme();
    let data = { genre: "", dateOfBirth: Date.now() }
    data = { ...props.props }
    return (
        <Card
            radius="md"
            withBorder
            p="lg"
            sx={(theme) => ({
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
            })}
        >
            <Card.Section bg={theme.colors.blue} p={"xs"} >
                <Title color='white' align="center" order={3}  >
                    Informations
                </Title>
            </Card.Section>
            <Card.Section m={"xs"}>
                <Text tt={'capitalize'} align="left">
                    Genre : {data.genre}
                </Text>
                <Text align="left">
                    Date de Naissance : {data.birthdate ? birthdateLine(data.birthdate) : "Aucune date de naissance au dossier"}
                </Text>
                <Text align='left'>
                    Langue de contact : {data.principalLanguages ? data.principalLanguages : "Aucune langue au dossier"}
                </Text>
                <Text>
                    Date d'inscription : {data.dateOfRegistration ? new Date(data.dateOfRegistration).toLocaleDateString("fr-CA", {day: "numeric",month: "long",year: "numeric",}) : ""}
                </Text>
            </Card.Section>
            <Divider my={"md"} />
            <Text align='left'>Adresse Civique : {data.civic ? data.civic : "Aucune adresse au dossier"}</Text>
            <Text align='left'>Ville : {data.city ? data.city : "Aucune ville au dossier"}</Text>
            <Text align='left'>Code Postal : {data.postal ? data.postal : "Aucun code au dossier"}</Text>
            <Text align="left">Notes : {data.note ? data.note : "Aucune note"}</Text>

        </Card>
    );
}

function birthdateLine(birthdate){
    let date = "";
    if(birthdate.day) date = date+ birthdate.day+ " ";
    if(birthdate.month) date = date + ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"][birthdate.month-1] + " "
    if(birthdate.year) date = date + birthdate.year;
    return date;
}